import React from 'react';
import type { TablePaginationConfig } from 'antd/es/table';
import { formatNumberWithCommas } from './utils';

export const DEFAULT_PAGE_SIZE_OPTIONS = ['10', '20', '50', '100'];

/**
 * Nhãn "1-20 của 59 bản ghi" cho Table.
 * Tổng số đã có sẵn trong response API (will_paginate luôn chạy COUNT để tính số trang)
 * nên hiển thị thêm không tốn query hay request nào.
 */
export const showTotalRecords = (total: number, range: [number, number]): React.ReactNode =>
  total > 0 ? (
    <span>
      {range[0]}-{range[1]} của <strong>{formatNumberWithCommas(total)}</strong> bản ghi
    </span>
  ) : (
    'Không có bản ghi nào'
  );

interface PaginationOptions {
  current?: number;
  pageSize?: number;
  total?: number;
}

/** Cấu hình phân trang chuẩn dùng chung cho mọi Table. */
export const tablePagination = ({ current, pageSize, total }: PaginationOptions): TablePaginationConfig => ({
  current,
  pageSize,
  total,
  showSizeChanger: true,
  showTotal: showTotalRecords,
  position: ['bottomRight'],
  pageSizeOptions: DEFAULT_PAGE_SIZE_OPTIONS,
});
